// test1078
(1078 && 0);
